export const TOTAL_CV_FIELDS = 18;

export const PRIMARY_BTN =
  'px-6 py-3 text-white font-medium text-sm transition-opacity hover:opacity-90 rounded-sm disabled:opacity-50';

export const PRIMARY_BG = '#0AC1CE';
